<template>
  <div class='mainContainer' v-loading='importLoading'>
      <div class='nav'>
        <div class='navContainer' style='width: 240px'>
          <p style="width: 100px">港口名称：</p>
          <el-select v-model="portName" filterable  size="mini"
                     style="margin-left:0px;width:100%" collapse-tags placeholder="请选择港口" @change="_getPortName(portName)">
            <el-option v-for="item in portOptions" :key="item.id" :label="item.portName"
                       :value="item.id"/>
          </el-select>
        </div>
        <div class='navContainer' style='width: 240px'>
          <p>品牌：</p>
          <el-select v-model="brandName" filterable  size="mini"
                     style="margin-left:0px;width:100%" collapse-tags placeholder="请选择品牌">
            <el-option v-for="item in brandOptions" :key="item.id" :label="item.brandName"
                       :value="item.id"/>
          </el-select>
        </div>
        <div class='navBtn'>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        </div>
      </div>
      <div class='content'>
        <div class='tableContainer'>
          <el-table
            v-loading='tableLoad'
            :data='TableDatas'
            style='width: 100%'
            border
            stripe
            :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
            :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          >
            <!-- <el-table-column label="序号" align="center" width="50px">
              <div slot-scope="scope">{{scope.$index+1}}</div>
            </el-table-column> -->
            <el-table-column prop='portName' label='港口名称' align='center' />
            <el-table-column prop='batchNumber' label='批次号' align='center' />
            <el-table-column prop='waybillNo' label='运单编号' align='center' />
            <el-table-column prop='frameNumber' label='车架号' align='center' />
            <el-table-column prop='brandName' label='品牌' align='center' />
            <el-table-column prop='modelName' label='型号' align='center' />
            <el-table-column label='进港类型' align='center'>
              <div slot-scope='scope'>{{ getType(scope.row.enterPortType) }}</div>
            </el-table-column>
            <el-table-column label='进港时间' align='center' width='130'>
              <div slot-scope='scope'>{{ getTime(scope.row.enterPortDate) }}</div>
            </el-table-column>
            <el-table-column prop='enterPortPeople' label='进港扫码人' align='center' />
            <el-table-column label='出港时间' align='center' width='130'>
              <div slot-scope='scope'>{{ getTime(scope.row.outPortDate) }}</div>
            </el-table-column>
            <el-table-column prop='outPortPeople' label='出港扫码人' align='center' />
            <el-table-column label='状态' align='center'>
              <div slot-scope='scope'>{{ getState(scope.row.state) }}</div>
            </el-table-column>
          </el-table>
        </div>
        <div class='paginationContainer'>
          <span>共{{ total }}条</span>
          <el-pagination
            background
            :page-sizes='[10, 20, 30, 40]'
            layout='sizes,prev, pager, next,jumper'
            :total='total'
            @size-change='contractSizeChange'
            @current-change='contractCurrentChange'
            @prev-click='contractCurrentChange'
            @next-click='contractCurrentChange'
          />
        </div>
      </div>
    </div>
</template>

<script>
import {getPortsList,getPortName, getPageListByPB,} from '@/service/vehiclelog';
import { formatDateTime} from '@/config/mUtils';
export default {
  data() {
    return {
      importLoading: false,
      portName: '',   // 港口名称
      portOptions: [], //港口列表
      id:'',
      brandName: '',   // 品牌
      brandOptions: [], // 品牌列表
      idToNameMap:'',
      tableLoad: false,
      TableDatas: [],
      page: 1,
      size: 10,
      total: 0,
      // 批量导入
      uploadUrl: '',  // 导入路径
      uploadData: {
        mFile: '',
      },
    }
  },
  computed: {
    getState() {
      return function(state) {
        switch (state) {
          case 0:
            return '已进港';
          case 1:
            return '已出港';
        }
      };
    },
    getType() {
      return function(state) {
        switch (state) {
          case 0:
            return '起始进港';
          case 1:
            return '司机交车进港';
          case 2:
            return '船舶交车进港';
        }
      };
    },
  },
  mounted() {
    this.init();
  },

  methods: {
    async init() {
      await this._getPortsList();
    },
    // 获取港口
    async _getPortsList() {
      let res = await getPortsList();
      if (res.status !== 0) return this.$message.error(res.message);
      this.portOptions = res.data;
    },
    // 获取品牌
    async _getPortName(selectedId) {
      this.brandName = '';
      let res = await getPortName({
        id: selectedId
      });
      if (res.status !== 0) return this.$message.error(res.message);
      this.brandOptions = res.data;
    },
    // 获取集港信息
    async getPageList() {
      this.tableLoad = true;
      let selectedPortName = this.portOptions.find(item => item.id === this.portName);
      let selectedBrandName = this.brandOptions.find(item => item.id === this.brandName);
      if(!selectedPortName || !selectedBrandName){
        this.$message.warning("请先选择港口名称和品牌！");
        this.tableLoad = false;
        return ;
      }
      let res = await getPageListByPB (
          {
            portName: selectedPortName.portName,
            brandName: selectedBrandName.brandName,
            rows: this.size,
            page: this.page,
          },
        );
      this.tableLoad = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.TableDatas = res.data.records;
      this.total = res.data.total;
    },
    // 改变每页条数时触发事件
    contractSizeChange(sizes) {
      this.size = sizes;
      this.getPageList();
    },
    // 改变当前页时触发事件
    contractCurrentChange(page) {
      this.page = page;
      this.getPageList();
    },
    // 查询
    searchBtn() {
      this.page = 1;
      this.getPageList();
    },
    // 时间格式
    getTime(time) {
      if (typeof (time) == 'string') {
        return formatDateTime(time, 'yyyy-mm-dd hh:ii');
      } else {
        return '';
      }
    },
    searchCopyFormat(value, flag) {
      let splitArr = value.clipboardData.getData('Text')
        .replace(/\s/g, ',')
        .split(',');
      splitArr = splitArr.filter(item => item);
      splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
      switch (flag) {
        case 'chassisIpt':
          this.chassisIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
          break;
      }
    },
  },
};
</script>


<style lang='scss' scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    .navContainer p {
      display: inline-block;
      width: 90px;
      text-align: right;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;

      .tableContainerNav {
        text-align: right;
        color: rgba(51, 136, 255, 1);

        span {
          display: inline-block;
          font-size: 16px;
          text-decoration: underline;

          i {
            font-size: 16px;
            text-decoration: underline;
          }
        }
      }

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .detail {
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height: 80vh;
    overflow: auto;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;

        &Item {
          margin-bottom: 20px;

          .span1 {
            font-weight: 700;
          }

          span {
            font-size: 14px;
          }

          .specialOne {
            width: 50%;
          }
        }

        .specialItem {
          display: flex;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      .stepContainer {
        margin: 10px 0 10px 20px;

        ::v-deep {
          .el-step__description.is-finish {
            color: #C0C4CC;
          }

          .el-step__description {
            color: #C0C4CC;
          }

          //.is-process{
          //  color: #C0C4CC;
          //}
        }
      }

      ::v-deep {
        .el-table td, .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }

  .company {
    width: 100%;
    height: 400px;
    padding: 20px 10px;
  }

  ::v-deep {
    .el-table th > .cell {
      font-weight: 700 !important;
    }
  }
}

::v-deep {
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .el-dialog__headerbtn {
    top: 9px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
